import {
  GetAllCharacterListRequest,
  GetCharacterDetailsRequest,
  GetCharacterTypeRequest,
  GetPersonaDetailsRequest,
} from '~/types';

const characterKey = {
  all: ['character'] as const,
  getListForCreation: () => [...characterKey.all, 'creation'] as const,
  getExploreCharacterList: () => [...characterKey.all, 'explore'] as const,
  getSearchCharacterList: (request: GetAllCharacterListRequest) =>
    [...characterKey.all, 'search', request.query] as const,
  getPopularCharacterList: () => [...characterKey.all, 'popular'] as const,
  getListByType: (request: GetCharacterTypeRequest) =>
    [...characterKey.all, 'byType', request?.type] as const,
  getCharacterDetails: (request: GetCharacterDetailsRequest) =>
    [...characterKey.all, 'details', request.character_id] as const,
  getCelebList: () => [...characterKey.all, 'celeb'] as const,
  getPersonaDetails: (request: GetPersonaDetailsRequest) =>
    [...characterKey.all, 'persona', request.character_id] as const,
} as const;

export default characterKey;
